import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'pt-document-work-in-progress',
  template: `
    <div class="work-in-progress">
      <label>Work in progress</label>
      <button type='button' class='btn btn-outline-primary btn-sm btn-back mt-2'
              (click)='goBack.emit(); $event.stopPropagation()'>
        {{ 'BUTTON.BACK' | translate }}
      </button>
    </div>
  `,
  styles: [`
    .work-in-progress {
      display: flex;
      width: 100%;
      height: calc(100% - 50px);
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    .work-in-progress label {
      font-size: 20px;
    }
  `]
})
export class DocumentWorkInProgressComponent {
  @Output() goBack = new EventEmitter<boolean>();
}
